export default __webpack_public_path__ + "static/de-8389cbd5631d45167a3227f58ee83642.svg";